import React from 'react';
import moment from 'moment';
import { b2cPagesService } from '@clubmed/utils';
import { renderInfoBanner } from 'Components/widgets/info-banner/infoBanner.utils';
import { getInfoBannerQuery } from 'Components/widgets/info-banner/infoBanner.query';
import { usePageContext } from 'Context/PageContext';
import { useGQL } from 'Utils/graphql-client/use-gql/useGQL';
import { WIDGET_PRODUCT_FETCH_INFORMATION_BANNERS } from 'Utils/request/requestDictionary';
import { STATIC_PAGE_TYPES } from 'Tracking/constants';
import { themes } from './InfoBanner.themes';
const { PAGE_TYPES } = b2cPagesService;
const pageMappings = {
  [PAGE_TYPES.RESORT]: 'resort_page',
  [PAGE_TYPES.PLE]: 'customer_area',
  [STATIC_PAGE_TYPES.SHOPPING_SEARCH]: 'comparator',
};
type Props = {
  className?: string;
  containerClassName?: string;
  contentClassName?: string;
  context?: string;
  departureDate: any;
  duration?: number;
  popinPosition?: string;
  productId: string;
  theme?: keyof typeof themes;
};
export const InfoBannerContainer = ({
  className,
  containerClassName,
  contentClassName,
  departureDate,
  duration,
  popinPosition,
  productId,
  theme = 'default',
}: Props) => {
  const appContext = usePageContext();
  const { data, isLoading } = useGQL({
    query: getInfoBannerQuery(productId),
    queryOptions: {
      requestName: WIDGET_PRODUCT_FETCH_INFORMATION_BANNERS,
    },
    cache: true,
  });
  const tripEndDate =
    departureDate && duration && moment(departureDate).add(duration, 'days').format('YYYY-MM-DD');
  return (
    !isLoading &&
    renderInfoBanner({
      infoBannerData: data,
      departureDate,
      arrivalDate: tripEndDate,
      currentStep: appContext.pageType && pageMappings[appContext.pageType],
      containerClassName,
      theme,
      contentClassName,
      popinPosition,
      className,
    })
  );
};
